import {
  FETCH_CATEGORIES_START,
  FETCH_CATEGORIES_SUCCESS,
  FETCH_CATEGORIES_ERROR,
  CREATE_CATEGORY_START,
  CREATE_CATEGORY_SUCCESS,
  CREATE_CATEGORY_ERROR,
  DELETE_CATEGORY_START,
  DELETE_CATEGORY_SUCCESS,
  DELETE_CATEGORY_ERROR,
  UPDATE_CATEGORY_START,
  UPDATE_CATEGORY_ERROR,
  UPDATE_CATEGORY_SUCCESS,
} from "./categories.types";

// Categories actions
export const fetchCategoriesStart = () => ({
  type: FETCH_CATEGORIES_START,
});
export const fetchCategoriesSuccess = (data) => ({
  type: FETCH_CATEGORIES_SUCCESS,
  payload: data,
});
export const fetchCategoriesError = (error) => ({
  type: FETCH_CATEGORIES_ERROR,
  payload: error,
});

// Single category actions
export const createCategoryStart = (category) => ({
  type: CREATE_CATEGORY_START,
  payload: category,
});

export const createCategorySuccess = (category) => ({
  type: CREATE_CATEGORY_SUCCESS,
  payload: category,
});

export const createCategoryError = (category) => ({
  type: CREATE_CATEGORY_ERROR,
  payload: category,
});

export const updateCategoryStart = (category) => ({
  type: UPDATE_CATEGORY_START,
  payload: category,
});

export const updateCategorySuccess = (category) => ({
  type: UPDATE_CATEGORY_SUCCESS,
  payload: category,
});

export const updateCategoryError = (category) => ({
  type: UPDATE_CATEGORY_ERROR,
  payload: category,
});

export const deleteCategoryStart = (category) => ({
  type: DELETE_CATEGORY_START,
  payload: category,
});

export const deleteCategorySuccess = (data) => ({
  type: DELETE_CATEGORY_SUCCESS,
  payload: data,
});

export const deleteCategoryError = (error) => ({
  type: DELETE_CATEGORY_ERROR,
  payload: error,
});
